import { createContext, useContext } from 'react'
import { CurrentUser } from './types'

/**
 * Modul nečte Keycloak přímo — dostává uživatele zvenku přes context.
 * V dev harness ho plní přepínač, v reálné aplikaci adaptér nad Keycloakem.
 */
const CurrentUserContext = createContext<CurrentUser | null>(null)

export const CurrentUserProvider = CurrentUserContext.Provider

export function useCurrentUser(): CurrentUser {
  const user = useContext(CurrentUserContext)
  if (!user) {
    throw new Error('useCurrentUser musí být použit uvnitř CurrentUserProvider')
  }
  return user
}
